(ns ui.view.card.decisions.view
  (:require
   [reagent.core :as r]
   [oops.core :as oops]
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.components.rich-text.tiptap :as tiptap]
   [ui.view.card.sub :as common-sub]
   [ui.view.card.event :as common-event]
   [ui.view.card.decisions.sub :as sub]
   [ui.view.card.decisions.event :as event]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card]
   [ui.view.card.shared-components.view :as card-shared]
   [ui.view.card.shared-components.entity-table :as entity-table]
   [re-frame.core :as rf]
   [common.util :as cu]
   [common.localization :as loc]
   [ui.components.grid.view :refer [ag-grid-enterprise theme-quartz]]
   [clojure.string :as string]
   [ui.components.hover-card.view :as hover-card]
   [common.entity :as entity]
   [ui.util :as uu]
   [ui.components.button.view :as button]
   [frontend.view.modals.decisions.event :as decision-modal-event]
   [frontend.view.modals.decisions.view :as decision-modal]
   [frontend.view.modals.events :as modals]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.view.card.entity-list.view :as entity-list-view]))


;; TODO: Add case where no options and when decisions not configured
(defn create-decision-button
  [{:keys [ctx]}]
  (let [options @(rf/subscribe [::sub/create-decision-options ctx])]
    [dropdown-menu/view
     {:items (->> options
                  (mapv (fn [{:keys [value] :as opt}]
                          (assoc opt
                                 :on-click
                                 (fn []
                                   ;; HACK
                                   (let [decision-id (uu/make-uuid)]
                                     (modals/open-modal!
                                      decision-modal/modal-key
                                      {:decision-id decision-id
                                       :submit-success-cb-event [::common-event/fetch-card-data
                                                                 (assoc ctx :reset-entities? true)]})
                                     (rf/dispatch [::decision-modal-event/open-create-modal
                                                   decision-id
                                                   value
                                                   (:entity-id ctx)])))))))
      :props {:align :end
              :hide-arrow? true}
      :trigger-as-child
      [:span
       [button/sm-secondary-hollow
        {}
        [:i {:class "fal fa-plus"}]
        (loc/tr :create-decision)]]}]))

(defn no-decisions-view
  [props]
  [:div
   {:class "h-72 flex flex-col items-center justify-center gap-8"}
   [:h4 (loc/tr :no-decisions-yet)]
   [create-decision-button props]])

(defn simple-entity-table
  [{:keys [data config on-grid-ready] :as args}]
  (let [{:keys [sort-model columns]} config
        sort-index-and-direction-by-field
        (->> sort-model
             (map-indexed
              (fn [idx {:keys [field direction]}]
                [field {:sort-index idx
                        :direction direction}]))
             (into {}))
        ag-row-data (entity-table/data->ag-row-data data)
        col-defs (->> columns
                      (map-indexed
                       (fn [col-ord {:keys [field label]}]
                         (let [last-column? (= col-ord (dec (count columns)))
                               sort? (contains? sort-index-and-direction-by-field field)]
                           (merge
                            {:headerName (or label (loc/tr field))
                             :flex (when last-column? 1)
                             :field (cu/kw->str field)
                             :valueGetter (partial entity-table/value-getter field)
                             :valueFormatter (partial entity-table/value-formatter field)
                             :comparator entity-table/column-value-comparator
                             :useValueFormatterForExport true}
                            (when (= field :entity/type)
                              {:minWidth 250})
                            ;; HACK
                            (when (#{:investment-reservation/expiry-date
                                     :investment-reservation/void-date}
                                   field)
                              {:width 120})
                            (when sort?
                              {:sortIndex (get-in sort-index-and-direction-by-field [field :sort-index])
                               :sort (get-in sort-index-and-direction-by-field [field :direction])})))))
                      (vec))]
    [:div
     {:style {:height "auto"}}
     [:div
      {:class "h-full w-full"}
      [ag-grid-enterprise
       (merge
        {:theme theme-quartz
         :columnDefs col-defs
         :rowData ag-row-data
         :onGridReady (fn [params]
                        (when (fn? on-grid-ready)
                          (on-grid-ready params)))
         :rowClass "group/row hover:bg-base-regular"
         :suppressContextMenu true
         :defaultColDef {:sortable true
                         :suppressHeaderMenuButton true
                         :suppressColumnsToolPanel true
                         :suppressFiltersToolPanel true
                         :autoSize true
                         :minWidth 100
                         :resizable true
                         :suppressMovable true
                         :menuTabs []}
         :useValueFormatterForExport true
         :processCellForClipboard (fn [params]
                                    (or (some-> params
                                                (oops/oget "value")
                                                (js->clj :keywordize-keys true)
                                                :materialized-value)
                                        ""))
         :getRowId (fn [params]
                     (-> params
                         (oops/oget "data")
                         (oops/oget "db/id")
                         (oops/oget "value")))
         :onRowClicked (fn [params])
         :suppressRowHoverHighlight true
         :groupDefaultExpanded 0
         :suppressMultiSort true
         :groupDisplayType :groupRows
         :domLayout :autoHeight
         :suppressFiltersToolPanel true})]]]))

(defn create-column-defs
  [{:keys [columns sort-model group-by-field] :as _props}]
  (let [sort-index-and-direction-by-field
        (->> sort-model
             (map-indexed
              (fn [idx {:keys [field direction]}]
                [field {:sort-index idx
                        :direction direction}]))
             (into {}))
        data-columns (->> columns
                          (map-indexed
                           (fn [col-ord {:keys [field label]}]
                             (let [last-column? (= col-ord (dec (count columns)))
                                   sort? (contains? sort-index-and-direction-by-field field)
                                   group? (= field group-by-field)]
                               (merge
                                {:headerName (or label (loc/tr field))
                                 :flex (when last-column? 1)
                                 :field (cu/kw->str field)
                                 :valueGetter (partial entity-table/value-getter field)
                                 :valueFormatter (partial entity-table/value-formatter field)
                                 :comparator entity-table/column-value-comparator
                                 :useValueFormatterForExport true}
                                (when (zero? col-ord)
                                  {:cellRenderer "agGroupCellRenderer"})
                                (when (= field :entity/type)
                                  {:minWidth 250})
                                (when group?
                                  {:rowGroup true})
                                (when sort?
                                  {:sortIndex (get-in sort-index-and-direction-by-field [field :sort-index])
                                   :sort (get-in sort-index-and-direction-by-field [field :direction])})))))
                          (vec))
        all-columns data-columns]
    all-columns))

(defn field-notes-hover-card
  [{:keys [notes]}]
  [hover-card/hover-card-primitive
   {:openDelay 200}
   [hover-card/hover-card-trigger-primitive
    [:span
     {:class "hover:text-base-light-text-paler"}
     [:i
      {:class "fal fa-comment"}]]]
   [hover-card/hover-card-content-primitive
    {:side :left
     :align :end
     :class "z-50 w-96 rounded-md border bg-base-light p-3 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"}
    [:div
     {:class "flex flex-col gap-1"}
     [:span
      {:class "text-xs m-0 text-base-light-text-paler"}
      (loc/tr :notes)]
     [:p
      {:class "text-wrap"}
      notes]]]])

(defn section-title
  [title]
  [:p
   {:class "text-sm m-0 font-medium text-base-light-text"}
   title])

(defn field-list-section
  [{:keys [decision-id ctx title data-sub-kw]}]
  (let [data @(rf/subscribe [data-sub-kw ctx decision-id])
        row-count (count data)]
    (when (pos? row-count)
      [:div
       {:class "flex flex-col gap-2"}
       [section-title title]
       [:div
        {:class "grid grid-cols-[70%_30%] border"}
        (->> data
             (map-indexed
              (fn [row-idx {:keys [field field-label materialized-value notes? notes]}]
                (let [last-row? (= row-idx (dec row-count))
                      odd-row? (odd? row-idx)]
                  ^{:key (str field)}
                  [:<>
                   ^{:key (str field "-label")}
                   [:div
                    {:class (uu/cm "text-balance py-2 pl-3 text-base-light-text"
                                   (when-not last-row?
                                     "border border-x-0 border-t-0"))}
                    [:p field-label]]

                   ^{:key (str field "-value")}
                   [:div
                    {:class (uu/cm "flex justify-end items-center gap-2 pr-3"
                                   (when-not last-row?
                                     "border border-x-0 border-t-0"))}
                    [:p
                     {:class "font-medium"}
                     (if (sequential? materialized-value)
                       (->> materialized-value
                            (mapv :label)
                            (string/join "; "))
                       materialized-value)]

                    (when notes?
                      [field-notes-hover-card {:notes notes}])]]))))]])))

(defn table-section
  [{:keys [table-id remove-detail-grid-info]}]
  (r/create-class
   {:component-will-unmount (fn []
                              (remove-detail-grid-info table-id))
    :reagent-render
    (fn [{:keys [table-id title data-sub-kw config-sub-kw decision-id ctx
                 add-detail-grid-info remove-detail-grid-info]}]
      (let [data @(rf/subscribe [data-sub-kw ctx decision-id])
            config @(rf/subscribe [config-sub-kw ctx decision-id])]
        [:div
         {:class "flex flex-col gap-2"}
         [section-title title]
         [simple-entity-table
          {:data data
           :config config
           :on-grid-ready (fn [params]
                            #_(js/console.log "ADD DETAIL " {:id table-id
                                                             :api (oops/oget params "api")})
                            (let [api (oops/oget params "api")]
                              (add-detail-grid-info {:id table-id
                                                     :api api})))}]]))}))

(defn row-detail-component
  [{:keys [decision-id ctx] :as props}]
  (let [decision @(rf/subscribe [::sub/decision ctx decision-id])
        decision-notes @(rf/subscribe [::sub/decision-notes ctx decision-id])
        decision-date-display-str @(rf/subscribe [::sub/decision-date-display-string ctx decision-id])
        participants? @(rf/subscribe [::sub/decision-has-participants? ctx decision-id])
        conditions? @(rf/subscribe [::sub/decision-has-conditions? ctx decision-id])
        investment-reservations? @(rf/subscribe [::sub/decision-has-investment-reservations? ctx decision-id])
        approvals-needed? @(rf/subscribe [::sub/decision-has-approvals-needed? ctx decision-id])]
    [:div
     {:class "p-5 flex flex-col gap-6 shadow-inner bg-base-light"}
     [:div
      {:class "flex justify-between items-center"}
      [:div
       {:class "flex items-center gap-3 items-center"}
       [:p
        {:class "text-lg font-medium"}
        (str (entity/display-string decision))]
       [:p
        {:class "text-base-light-text-paler"}
        decision-date-display-str]]

      [button/sm-secondary-hollow
       {:on-click (fn []
                    (modals/open-modal!
                     decision-modal/modal-key
                     {:decision-id decision-id
                      :submit-success-cb-event [::common-event/fetch-card-data
                                                (assoc ctx :reset-entities? true)]})
                    (rf/dispatch [::decision-modal-event/open-editor-modal decision-id]))}
       [:i
        {:class "fal fa-pencil"}]
       (loc/tr :edit-decision)]]

     [field-list-section
      (merge
       props
       {:title (loc/tr :decision-details)
        :data-sub-kw ::sub/decision-details-data})]

     (when participants?
       [table-section
        (merge
         props
         {:table-id (str decision-id "-participants")
          :title (loc/tr :decision-participants)
          :decision-id decision-id
          :data-sub-kw ::sub/decision-participants-table-data
          :config-sub-kw ::sub/decision-participants-table-config})])

     (when investment-reservations?
       [table-section
        (merge
         props
         {:table-id (str decision-id "-investment-reservations")
          :title (loc/tr :investment-reservations)
          :decision-id decision-id
          :data-sub-kw ::sub/decision-investment-reservations-table-data
          :config-sub-kw ::sub/decision-investment-reservations-table-config})])

     (when conditions?
       [table-section
        (merge
         props
         {:table-id (str decision-id "-conditions")
          :title (loc/tr :conditions)
          :decision-id decision-id
          :data-sub-kw ::sub/decision-conditions-table-data
          :config-sub-kw ::sub/decision-conditions-table-config})])

     (when approvals-needed?
       [field-list-section
        (merge
         props
         {:title (loc/tr :approvals-needed)
          :data-sub-kw ::sub/decision-approvals-needed-data})])

     (when (cu/non-empty-string? decision-notes)
       [:div
        {:class "flex flex-col gap-1"}
        [:p
         {:class "text-sm m-0 font-medium text-base-light-text"}
         (loc/tr :notes)]
        [tiptap/viewer {:value decision-notes}]])]))

(defn decisions-table
  [{:keys [ctx card] :as props}]
  (let [table-data @(rf/subscribe [::sub/decisions-table-data ctx])
        expanded-decision-ids @(rf/subscribe [::sub/expanded-decision-ids ctx])
        table-config (-> card
                         :card/config
                         :table)
        col-defs (create-column-defs table-config)
        ag-row-data (entity-table/data->ag-row-data table-data)]
    [:div
     {:style {:height "auto"}}
     [:div
      {:class "h-full w-full"}
      [ag-grid-enterprise
       (merge
        {:theme theme-quartz
         :columnDefs col-defs
         :rowData ag-row-data
         :masterDetail true
         :suppressContextMenu true
         :defaultColDef {:sortable true
                         :suppressHeaderMenuButton true
                         :suppressColumnsToolPanel true
                         :suppressFiltersToolPanel true
                         :autoSize true
                         :minWidth 150
                         :resizable true
                         :suppressMovable true
                         :menuTabs []}
         :embedFullWidthRows true
         :useValueFormatterForExport true
         :processCellForClipboard (fn [params]
                                    (or (some-> params
                                                (oops/oget "value")
                                                (js->clj :keywordize-keys true)
                                                :materialized-value)
                                        ""))
         :onGridReady (fn [params]
                        (uu/timeout
                         0
                         #(let [api (oops/oget params "api")]
                            (doseq [decision-id expanded-decision-ids]
                              (when-let [row-node (oops/ocall api "getRowNode" decision-id)]
                                (oops/ocall row-node "setExpanded" true))))))
         :getRowId (fn [params]
                     (-> params
                         (oops/oget "data")
                         (oops/oget "db/id")
                         (oops/oget "value")))
         :onRowGroupOpened (fn [params]
                             (let [decision-id (-> params
                                                   (oops/oget "data")
                                                   (oops/oget "db/id")
                                                   (oops/oget "value"))
                                   expanded? (-> params
                                                 (oops/oget "expanded"))]
                               (rf/dispatch [::event/set-decision-expanded ctx {:decision-id decision-id
                                                                                :expanded? expanded?}])))
         :detailRowAutoHeight true
         :detailCellRenderer (fn [params]
                               (let [js-data (oops/oget params "data")
                                     parent-grid-api (oops/oget params "api")
                                     decision-id (-> js-data
                                                     (oops/oget "db/id")
                                                     (oops/oget "value"))
                                     data (js->clj js-data :keywordize-keys true)

                                     add-detail-grid-info
                                     (fn [{:keys [id api] :as args}]
                                       (oops/ocall parent-grid-api "addDetailGridInfo" id (clj->js {:id id
                                                                                                    :api api})))

                                     remove-detail-grid-info
                                     (fn [id]
                                       (when-not false
                                         (oops/ocall parent-grid-api "removeDetailGridInfo" id)))]
                                 (r/as-element
                                  [row-detail-component
                                   (assoc props
                                          :data data
                                          :decision-id decision-id
                                          :add-detail-grid-info add-detail-grid-info
                                          :remove-detail-grid-info remove-detail-grid-info)])))
         :onRowClicked (fn [params])
         :suppressRowHoverHighlight true
         :groupDefaultExpanded 0
         :suppressMultiSort true
         :groupDisplayType :groupRows
         :domLayout :autoHeight
         :suppressFiltersToolPanel true})]]]))

(defn loading-view
  []
  [entity-list-view/loading-skeleton])

(defn loading-error-view
  [{:keys [ctx] :as props}]
  [:div
   {:class "h-72 flex flex-col items-center justify-center gap-4"}
   [:i
    {:class "fal fa-exclamation-triangle text-3xl text-danger"}]
   [:h4 (loc/tr :error-loading-data)]
   [button/sm-secondary-hollow
    {:on-click #(rf/dispatch [::common-event/fetch-card-data ctx])}
    (loc/tr :retry)]])

(defn component
  [{:keys [card ctx loading? loading-error? decisions?] :as props}]
  (let [title (:card/title card)]
    [card-container/view
     [:div
      {:class "flex justify-between py-2"}
      [card-title/view title]
      [:div
       {:class "flex items-center gap-2"}
       (when decisions?
         [create-decision-button props])
       [card-shared/expand-card props]]]
     (cond
       loading?
       [loading-view]

       loading-error?
       [loading-error-view props]

       decisions?
       [decisions-table props]

       :else
       [no-decisions-view props])]))

(defn full-screen-component
  [{:keys [loading? loading-error? decisions?] :as props}]
  [full-screen-card/view
   (merge
    props
    {:header-right-actions (when decisions?
                             [create-decision-button props])})
   (cond
     loading?
     [loading-view]

     loading-error?
     [loading-error-view props]

     decisions?
     [decisions-table props]

     :else
     [no-decisions-view props])])

(defn view
  [{:keys [full-screen? ctx] :as initial-props}]
  (let [loading? @(rf/subscribe [::sub/loading? ctx])
        loading-error? @(rf/subscribe [::common-sub/loading-error? ctx])
        decisions? @(rf/subscribe [::sub/entity-has-decisions? ctx])
        props (assoc initial-props
                     :loading? loading?
                     :loading-error? loading-error?
                     :decisions? decisions?)]
    (if full-screen?
      [full-screen-component props]
      [component props])))
